import { render, staticRenderFns } from "./landingPageSellStrategy.vue?vue&type=template&id=93624b80&scoped=true"
import script from "./landingPageSellStrategy.vue?vue&type=script&lang=js"
export * from "./landingPageSellStrategy.vue?vue&type=script&lang=js"
import style0 from "./landingPageSellStrategy.vue?vue&type=style&index=0&id=93624b80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93624b80",
  null
  
)

export default component.exports